import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "asMenuModal" }
const _hoisted_2 = {
  key: 0,
  class: "asMenuModal_modal"
}
const _hoisted_3 = { class: "asMenuModal_content" }
const _hoisted_4 = { class: "asMenuModal_header" }
const _hoisted_5 = { class: "asMenuModal_list" }
const _hoisted_6 = {
  key: 0,
  class: "asMenuModal_note"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "asMenuModal_icon -ext" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "asMenuModal_icon -exit" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
      class: "asMenuModal_button"
    }),
    (_ctx.open)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#modals"
        }, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.open)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_ctx.open)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                          class: "asMenuModal_overlay"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('menu')), 1),
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, i) => {
                          return (_openBlock(), _createBlock(_component_router_link, {
                            key: i,
                            to: item.link,
                            class: "asMenuModal_item",
                            "data-analytics": "",
                            "data-analytics-element-type": "menu_user",
                            "data-analytics-element-target": item.link,
                            "data-analytics-element-id": item.icon,
                            "data-analytics-element-name": item.name
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(["asMenuModal_icon", `${item.icon}`])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                              (item.update)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.update), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]))
                        }), 128)),
                        (_ctx.user.isAdmin)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "asMenuModal_item",
                              href: _ctx.urlAdmin
                            }, [
                              _hoisted_8,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard')), 1)
                            ], 8, _hoisted_7))
                          : _createCommentVNode("", true),
                        _createVNode(_component_router_link, {
                          to: "/logout",
                          class: "asMenuModal_item"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('exit')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}